import { useState,useEffect } from "react";
import styles from "./TherapistCaseNotesDetails.module.css";
import axios from "axios";
import { useLocation } from "react-router-dom";

const TherapistCaseNotesDetails = () => {
    const [therapyGoals, setTherapyGoals] = useState("");
    const [keyObservations, setKeyObservations] = useState("");
    const [attachments, setAttachments] = useState(null); // Assuming file upload
    const location = useLocation();
    const userID = location.state?.userID;
    const [token, setToken] = useState(null);

    useEffect(() => {
        // Retrieve token from localStorage or your preferred storage method
        const storedToken = localStorage.getItem('token'); // Replace with your actual key
        if (storedToken) {
            setToken(storedToken);
        }
    }, []);

    const handleSubmit = async () => {
        if (!token) {
            console.error("Token not available. User not authenticated?");
            return;
        }

        try {
            const formData = new FormData();
            formData.append("therapyGoals", therapyGoals);
            formData.append("keyObservations", keyObservations);
            if (attachments) formData.append("attachments", attachments); // Assuming single file upload

            const response = await axios.post(`${process.env.REACT_APP_SERVER_URI}/api/therapist/client/${userID}/sendCaseNotes`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data', // Required for file uploads
                },
            });

            if (response.status === 200) {
                console.log("Case notes submitted successfully!");
                // Optionally, redirect or show a success message
            } else {
                console.error("Error submitting case notes:", response.data);
                // Handle errors appropriately (e.g., display error message)
            }
        } catch (error) {
            console.error("Error submitting case notes:", error);
            // Handle network errors or other exceptions
        }
    };

    const handleFileChange = (e) => {
        setAttachments(e.target.files[0]); // Assuming single file upload
    };

    // Function to get current date and time
    const getCurrentDateTime = () => {
        const now = new Date();
        const options = { weekday: 'short', month: 'short', day: 'numeric' };
        const dateString = now.toLocaleDateString('en-US', options);
        const timeString = now.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
        return { date: dateString, time: timeString };
    };

    const { date, time } = getCurrentDateTime();

    return (
        <div className="caseNotes-Container" style={{backgroundColor:'#fffcf8'}}>
        <div className={styles['caseNotes-backArrow-Bg']}>
            <img src="https://ucarecdn.com/8c1645b5-ac4b-49d2-b2e2-f66eab1186da/leftVector.svg" alt="back"/>
        </div>
        <div className={styles['caseNotes-header-row']}>
            <div className={styles['caseNotes-pic-bg']}>
            <img src="https://ucarecdn.com/c7bb4c01-2258-428d-b8ce-e2196ee63220/lgbtq.svg" alt="profile picture"/>
            </div>
            <div className={styles['caseNotes-header-data']}>
                <div className={styles['caseNotes-header-row']}>
                <div>
                <p className={styles['caseNotes-data-heading']} style={{fontSize:'20px'}}>Swarangi Yeole</p>
                <p className={styles['caseNotes-AgeData-heading']}>Age:<p className={styles['caseNotes-AgeData-details']}>18 yrs</p></p>
                </div>
                <div className={styles['caseNotes-msg-bg']}>
                    <img src="https://ucarecdn.com/83c14859-a37e-4a28-9665-f3b2e819b5be/chatIcon.svg" alt="msg" className={styles['caseNotes-msg-icon']}/>
                </div>
                </div>
                <div className={styles['caseNotes-client-details']}>
                <p className={styles['caseNotes-data-heading']}>Problems:<p className={styles['caseNotes-data-details']}>Anxiety</p></p>
                <p className={styles['caseNotes-data-heading']}>Last Session Date:<p className={styles['caseNotes-data-details']}>08 Dec, 24</p></p>
                <p className={styles['caseNotes-data-heading']}>Problem description:<p className={styles['caseNotes-data-details']}>Feeling anxious often, which makes it difficult to do regular things</p></p>
                </div>
            </div>
        </div>

        <div className={styles['caseNotes-dateTime-header']}>
        <div className={styles['caseNotes-backArrows-Bg']} style={{alignSelf:'center'}}>
            <img src="https://ucarecdn.com/8c1645b5-ac4b-49d2-b2e2-f66eab1186da/leftVector.svg" alt="back"/>
        </div>
        <div className={styles['caseNotes-dateTime-heading-data']}>
        <p className={styles['caseNotes-dateTime-heading']}>Session Date & Time</p>
        <div className={styles['caseNotes-time-Date-main']}>
            <div className={styles['caseNotes-time-Date']} style={{marginRight:'8px'}}>
            <div className={styles['caseNotes-clockICon']}>
            <img src="https://ucarecdn.com/d8eed506-936b-4c72-8caa-0896db287024/greenCalendar.svg" alt="arrow"/>
            </div>
            <p className={styles['caseNotes-sessions-data']}>{date}</p>
            </div>
            <div className={styles['caseNotes-time-Date']} style={{marginLeft:'8px'}}>
            <div className={styles['caseNotes-clockICon']}>
            <img src="https://ucarecdn.com/71126e9a-41ad-4f9c-9515-30404b6025d5/greenClock.svg" alt="arrow"/>
            </div>
            <p className={styles['caseNotes-sessions-data']}>{time}</p>
            </div>
        </div>
        </div>
        <div className={styles['caseNotes-backArrows-Bg']} style={{alignSelf:'center'}}>
            <img src="https://ucarecdn.com/b9b53482-7b61-4400-8f7a-d2006d27c903/rightVector.svg" alt="back"/>
        </div>
        </div>
        <div className={styles['caseNotes-dateTime-header']}>
            <div className={styles['caseNotes-headingAndInput']}>
                <p className={styles['caseNotes-input-heading']}>Therapy Goals</p>
                <input
                    className={styles['caseNotes-largeInput-box']}
                    value={therapyGoals}
                    onChange={(e) => setTherapyGoals(e.target.value)}
                />
            </div>
            <div className={styles['caseNotes-headingAndInput']}>
                <p className={styles['caseNotes-input-heading']}>Key Observations</p>
                <input
                    className={styles['caseNotes-largeInput-box']}
                    value={keyObservations}
                    onChange={(e) => setKeyObservations(e.target.value)}
                />
            </div>
        </div>
        <div className={styles['caseNotes-dateTime-header']}>
            <div className={styles['caseNotes-headingAndInput']}>
                <p className={styles['caseNotes-input-heading']}>Add Attachments</p>
                <div className={styles['caseNotes-attachmentInput-wrapper']}>
                <img
                    src="https://ucarecdn.com/559b2d3c-b120-47fc-85ac-b03affd2efcb/documentIcon.svg"
                    alt="attachment"
                    className={styles['caseNotes-attachmentInput-icon']}
                />
                <input
                    className={styles['caseNotes-hiddenInput']}
                    type="file"
                    onChange={handleFileChange}
                />
                </div>
            </div>
            <div className={styles['caseNotes-headingAndInput']}>
                <button className={styles['caseNotes-submitButton']} onChange={handleSubmit}>Submit Now</button>
            </div>
        </div>
    </div>
    );
};

export default TherapistCaseNotesDetails;